import React, { useState } from "react";
import { VscEye } from "react-icons/vsc";
import { CiMobile3, CiLinkedin } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import "../../assets/styles/common.css";

function SideFlexScreen({ userInfo, count }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleToggleDialog = () => {
    setDialogOpen((prev) => !prev);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
    });
  };

  return (
    <div className={`user-profile-container ${dialogOpen ? "expanded" : ""}`}>
      <div
        className="icon_screen"
        style={{ width: "100%" }}
        onClick={handleToggleDialog}
      >
        <span>Profile Views: {count || 0}</span>
        <VscEye size={24} />
      </div>
      <div
        className="icon_screen"
        style={{ width: "100%" }}
        onClick={handleToggleDialog}
      >
        <span
          onClick={(e) => {
            e.stopPropagation();
            handleCopy(userInfo?.mobile_no);
          }}
        >
          {userInfo?.mobile_no}
        </span>
        <CiMobile3 size={24} />
      </div>
      <div
        className="icon_screen"
        onClick={handleToggleDialog}
        style={{ width: "100%" }}
      >
        <span
          className="copy-texts"
          onClick={(e) => {
            e.stopPropagation();
            handleCopy(userInfo?.email);
          }}
        >
          {userInfo?.email}
        </span>
        <PiMailboxLight size={24} />
      </div>
      <div
        className="icon_screen"
        style={{ width: "100%" }}
        onClick={handleToggleDialog}
      >
        <span
          className="copy-texts"
          onClick={(e) => {
            e.stopPropagation();
            handleCopy(userInfo?.linkedInURL);
          }}
        >
          LinkedIn: {userInfo?.linkedin_profile_url}
        </span>
        <CiLinkedin size={24} />
      </div>
    </div>
  );
}

export default SideFlexScreen;
